export default __webpack_public_path__ + "static/hybrid-global-system-54bbc3627b94f0ec32b3ccd789c5e6dc.png";